import { useCallback, useState } from "react";
import { useHandleResize } from "./useHandleResize";

type ScrollbarSizeProps = {
  horizontalScrollbarSize: number;
  verticalScrollbarSize: number;
};

function getScrollbarSize(): ScrollbarSizeProps {
  const hasWindow = typeof window !== "undefined";

  if (!hasWindow) {
    return {
      horizontalScrollbarSize: 0,
      verticalScrollbarSize: 0,
    };
  }

  // Idea stolen from https://stackoverflow.com/a/57748743/349353
  return {
    horizontalScrollbarSize: window.innerWidth - document.documentElement.clientWidth,
    verticalScrollbarSize: window.innerHeight - document.documentElement.clientHeight,
  };
}

export function useScrollbarSize(): ScrollbarSizeProps {
  const [scrollbarSize, setScrollbarSize] = useState(getScrollbarSize);

  const updateWindowSize = useCallback(() => {
    setScrollbarSize(getScrollbarSize());
  }, []);

  useHandleResize(updateWindowSize);

  return scrollbarSize;
}
